<template lang="pug">

.teachers-page
  .content-container
    v-card.teachers-card
      v-card-title.teachers-title {{ isSchool ? 'Учителя' : 'Преподаватели' }}

      v-card-text.pa-6
        v-row.teachers-row
          v-col(
            v-for="col, i in cols"
            :key="i"
            align-self="start"
            :class="{ full: fullTeacherFio }"
          )
            .teachers-column
              .letter {{ getKey(col[0].fio) }}

              router-link.teacher-link(
                v-for="teacher in col"
                :key="teacher.id"
                :to="{ name: 'teachers_lessons', params: { teacherId: teacher.id }}"
              ) {{ getTeacher(teacher) }}

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import store from '@/store'
import { shortFio } from '@/common'

export default {
  name: 'Teachers',

  async beforeRouteEnter(to, from, next) {
    await store.dispatch('dictionaries/fetchTeachers')

    store.commit('breadcrumbs/update', [{ text: store.getters['bootstrap/isSchool'] ? 'Учителя' : 'Преподаватели' }])
    next()
  },

  computed: {
    ...mapState('dictionaries', ['teachers']),
    ...mapGetters('bootstrap', ['isSchool', 'fullTeacherFio']),

    cols() {
      const result = []
      let lastArr = []

      for (const teacher of this.teachers) {
        const lastFio = lastArr[lastArr.length - 1]?.fio || ''

        if (this.getKey(lastFio) !== this.getKey(teacher.fio)) {
          if (lastArr.length) result.push(lastArr)

          lastArr = [teacher]
        } else {
          lastArr.push(teacher)
        }
      }

      if (lastArr.length) result.push(lastArr)

      return result
    },
  },

  methods: {
    getKey(str) {
      if (!str?.trim()) return null

      return str[0].toUpperCase()
    },

    getTeacher(item) {
      return this.fullTeacherFio ? item.fio : shortFio(item.fio)
    }
  },
}
</script>

<style lang="sass" scoped>

.teachers-page
  padding-bottom: 40px

.content-container
  max-width: 1200px
  margin: 0 auto
  padding: 0 24px

.teachers-card
  background: white
  box-shadow: 0 2px 8px rgba(0,0,0,0.1)
  border: 1px solid #e2e8f0
  margin-top: 20px

.teachers-title
  color: #1e293b
  font-size: 1.5rem
  font-weight: 600
  padding: 24px 24px 0
  border-bottom: 1px solid #f1f5f9

.teachers-row
  margin: 0

.teachers-column
  display: flex
  flex-direction: column

.col
  flex: 0 0 14%
  max-width: 14%
  padding: 0 12px

  &.full
    flex: 0 0 16%
    max-width: 16%

.teacher-link
  display: flex
  align-items: center
  min-height: 32px
  text-decoration: none
  line-height: 1.4
  color: #3b82f6
  font-size: 14px
  padding: 4px 8px
  border-radius: 6px
  transition: all 0.2s ease
  touch-action: manipulation
  -webkit-tap-highlight-color: transparent

  // Hover only for devices with mouse
  @media (hover: hover)
    &:hover
      background: rgba(59, 130, 246, 0.1)
      text-decoration: none
      color: #1e40af

  // Active state for touch devices
  &:active
    background: rgba(59, 130, 246, 0.15)
    transform: scale(0.98)

  &:not(:first-child)
    margin-top: 2px

.letter
  font-size: 18px
  font-weight: 700
  color: #64748b
  padding: 8px 8px 12px
  margin-bottom: 8px
  border-bottom: 2px solid #e2e8f0

// Responsive breakpoints
@media (max-width: 1266px)
  .col
    flex: 0 0 16.66%
    max-width: 16.66%

@media (max-width: 1200px)
  .col
    flex: 0 0 16.66%
    max-width: 16.66%

@media (max-width: 1100px)
  .col
    flex: 0 0 20%
    max-width: 20%

@media (max-width: 1000px)
  .col
    flex: 0 0 25%
    max-width: 25%

@media (max-width: 768px)
  .content-container
    padding: 0 16px

  .teachers-title
    font-size: 1.25rem
    padding: 20px 20px 0

  .col
    flex: 0 0 33.33%
    max-width: 33.33%
    padding: 0 8px

@media (max-width: 600px)
  .col
    flex: 0 0 50%
    max-width: 50%

@media (max-width: 480px)
  .content-container
    padding: 0 20px

  .teachers-title
    font-size: 1.1rem
    padding: 16px 16px 0

  .teacher-link
    font-size: 13px
    min-height: 28px

@media (max-width: 360px)
  .col
    flex: 0 0 100%
    max-width: 100%

// Full name styles
@media (max-width: 1266px)
  .full.col
    flex: 0 0 20%
    max-width: 20%

@media (max-width: 1200px)
  .full.col
    flex: 0 0 20%
    max-width: 20%

@media (max-width: 1100px)
  .full.col
    flex: 0 0 25%
    max-width: 25%

@media (max-width: 1000px)
  .full.col
    flex: 0 0 33.33%
    max-width: 33.33%

@media (max-width: 768px)
  .full.col
    flex: 0 0 50%
    max-width: 50%

@media (max-width: 480px)
  .full.col
    flex: 0 0 100%
    max-width: 100%
</style>
